import {EyeIcon} from "@/components/shared";
import {CircularProgress} from "@nextui-org/react";
import React, {useEffect, useState} from "react";
import Loader from "../Loader";

interface pollutiondatasProps {
  range: never[];
  upToDate: boolean;
  total: number;
  active: number;
  expired: number;
  noData: number;
  permitpercentage: string;
}
interface PollutionSummaryProps {
  isLoading: boolean;
  pollutiondatas: pollutiondatasProps;
  openPopup: (title: popupParams) => void;
}

type percentageData = {
  activePer: number;
  expiredPer: number;
  noDataPer: number;
};
const PollutionSummaryWidget: React.FC<PollutionSummaryProps> = ({
  isLoading,
  pollutiondatas,
  openPopup
}) => {
  const [percentageData, setpercentageData] = useState<percentageData>({
    activePer: 0,
    expiredPer: 0,
    noDataPer: 0
  });

  useEffect(() => {
    const totalVehicle = pollutiondatas.total;
    const activePer = pollutiondatas.active
      ? parseFloat(((pollutiondatas.active / totalVehicle) * 100).toFixed(2))
      : 0;

    const expiredPer = pollutiondatas.expired
      ? parseFloat(((pollutiondatas.expired / totalVehicle) * 100).toFixed(2))
      : 0;

    const noDataPer = pollutiondatas.noData
      ? parseFloat(((pollutiondatas.noData / totalVehicle) * 100).toFixed(2))
      : 0;

    setpercentageData({
      activePer: activePer,
      expiredPer: expiredPer,
      noDataPer: noDataPer
    });
  }, [pollutiondatas]);
  return (
    <>
      <div className="rounded-2xl border bg-neo-white">
        <div className="p-2">
          <div className="flex items-center justify-between px-2">
            <h5 className="text-lg font-semibold">
              Pollution Certificate Summary
            </h5>
            <h5
              className="cursor-pointer"
              title="View"
              onClick={() => openPopup({title: "Pollution Summary"})}
            >
              <EyeIcon size={18} />
            </h5>
          </div>
          <div className="flex items-center justify-between px-2">
            {/* <p className="text-sm text-gray-500">
              Pollution summary of vehicles in the fleet.
            </p> */}
          </div>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="flex items-center justify-between rounded-xl bg-[#FEF3E2] px-3 py-2">
                <div
                  className="flex cursor-pointer flex-col"
                  onClick={() =>
                    openPopup({
                      title: "Pollution Summary",
                      filter: {status: []}
                    })
                  }
                >
                  <div className="flex flex-row items-center gap-2">
                    <div className="text-sm text-gray-500">Total</div>
                    <div className="text-xl font-bold text-neo-black">
                      {pollutiondatas.total}
                    </div>
                  </div>
                </div>
                {!pollutiondatas.upToDate && (
                  <div className="flex items-center gap-6">
                    <div>
                      <h5 className="text-xs font-semibold text-[#EA580C]">
                        Expiring
                      </h5>
                      <h5 className="text-xs text-gray-500">Soon</h5>
                    </div>
                    <div className="flex items-center gap-1 rounded-full bg-white px-3 py-1.5">
                      <img
                        className="h-5 w-5 max-w-xs p-1"
                        src="/icons/bolt-blue.svg"
                      />
                      {pollutiondatas.range.length > 0 ? (
                        pollutiondatas.range.map(
                          (permits: any, index: number) =>
                            permits.days === 30 ? (
                              <h5 key={index} className="mr-2 text-xs">
                                30 days{" "}
                                <span className="text-[#006DED]">
                                  {permits.count} Permits
                                </span>
                              </h5>
                            ) : null
                        )
                      ) : (
                        <h5 className="mr-2 text-xs ">
                          30 days{" "}
                          <span className="text-[#006DED]">0 Permits</span>
                        </h5>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="flex flex-row items-center justify-between gap-1 p-2">
                {/* <div className="flex w-[20%] flex-col p-2">
                  <p className="text-base font-semibold text-slate-500 ">
                    Total
                  </p>
                  <p className="text-xl font-bold text-neo-black ">
                    {pollutiondatas.total}
                  </p>
                </div>
                <div className="flex w-[80%] justify-between gap-6 rounded-md bg-red-100 p-2">
                  <div className="flex flex-col">
                    <p className="text-lg font-extrabold text-red-600">
                      {pollutiondatas.expired} PC
                    </p>
                    <p className="text-xs text-slate-600">Will be expired</p>
                  </div>
                  <div className="flex">
                    <select className="rounded-full border border-gray-300 bg-white p-2 px-4 ">
                      <option value="30">30 days</option>
                      <option value="60">60 days</option>
                      <option value="90">90 days</option>
                    </select>
                  </div>
                </div> */}
              </div>

              {/* Active grids */}
              <div className="flex flex-row items-center justify-between gap-2 p-1">
                {[
                  {
                    id: 1,
                    label: "Active PC",
                    value: pollutiondatas.active,
                    percentage: percentageData.activePer,
                    color: "success",
                    strokeColor: "#16a34a"
                  },
                  {
                    id: 2,
                    label: "Expired PC",
                    value: pollutiondatas.expired,
                    percentage: percentageData.expiredPer,
                    color: "danger",
                    strokeColor: "#dc2626"
                  },
                  {
                    id: 3,
                    label: "No Data",
                    value: pollutiondatas.noData,
                    percentage: percentageData.noDataPer,
                    color: "default",
                    strokeColor: "#6b7280"
                  }
                ].map((item, index) => (
                  <div key={index} className="flex flex-col items-center p-1">
                    <h5 className="text-sm font-semibold text-slate-400 ">
                      {item.label}
                    </h5>
                    <h5
                      className="cursor-pointer text-2xl font-semibold"
                      onClick={() =>
                        openPopup({
                          title: "Pollution Summary",
                          filter: {status: [item.id]}
                        })
                      }
                    >
                      {item.value}
                    </h5>
                    <div className="relative mt-2 flex items-center justify-center">
                      {/* <CircularProgress
                        aria-label="Loading..."
                        color={
                          (item?.color as "success" | "danger" | "default") ||
                          "default"
                        }
                        strokeWidth={4}
                        size="lg"
                        value={item.percentage}
                        showValueLabel={true}
                      /> */}
                      <CircularProgress
                        classNames={{
                          svg: "w-16 h-16 drop-shadow-md",
                          //indicator: "stroke-yellow",
                          //track: "stroke-white/10",
                          value: "text-md font-semibold"
                        }}
                        color={
                          (item?.color as "success" | "danger" | "default") ||
                          "default"
                        }
                        showValueLabel={true}
                        strokeWidth={4}
                        value={item.percentage}
                      />
                      {/* <span
                        className={`absolute text-sm font-semibold ${item.color}`}
                      >
                        {item.percentage}%
                      </span> */}
                    </div>
                  </div>
                ))}
              </div>
            </>

            // <div className="flex flex-col gap-2">
            //   <div className="flex flex-col  p-1">
            //     <div className="flex items-center justify-between">
            //       <h5 className="flex flex-col items-start text-xl font-semibold">
            //         <div className="flex items-center">
            //           {permitdatas.total}
            //           <span className="ml-3 text-sm text-slate-400">
            //             Total Vehicles
            //           </span>
            //         </div>
            //       </h5>
            //     </div>
            //   </div>
            //   {!permitdatas.upToDate && (
            //     <div className="rounded-full border-[#FFC7271A] bg-[#FFC7271A] p-2">
            //       <div className="flex justify-between">
            //         <div className="ml-2 items-start">
            //           <h5 className="font-semibold text-red-500">Expiring</h5>
            //           <h5 className="text-sm">Soon</h5>
            //         </div>
            //         <h5 className="items-end text-base font-semibold">
            //           <div className="justify-left mt-2 flex items-center rounded-full border-[#E5E7EB] bg-[#E5E7EB]">
            //             <img
            //               className="h-8 w-8 max-w-xs p-1"
            //               src="/icons/bolt-blue.svg"
            //             />
            //             {permitdatas.range.length > 0 ? (
            //               permitdatas.range.map(
            //                 (permits: any, index: number) =>
            //                   permits.days === 30 ? (
            //                     <>
            //                       <h5
            //                         key={index}
            //                         className="mr-2 text-sm "
            //                       >
            //                         30 days{" "}
            //                         <span className="text-[#006DED]">
            //                           {permits.count} Permits
            //                         </span>
            //                       </h5>
            //                     </>
            //                   ) : null
            //               )
            //             ) : (
            //               <h5 className="mr-2 text-sm ">
            //                 30 days{" "}
            //                 <span className="text-[#006DED]">0 Permits</span>
            //               </h5>
            //             )}
            //           </div>
            //         </h5>
            //       </div>
            //     </div>
            //   )}

            //   <div className="w-full">
            //     <div className="flex h-4 w-full overflow-hidden rounded-md">
            //       <div
            //         className=" bg-green-500"
            //         style={{width: `${percentageData.activePer}%`}}
            //         title={`${percentageData.activePer}%`}
            //       />
            //       <div
            //         className="bg-red-500"
            //         style={{width: `${percentageData.expiredPer}%`}}
            //         title={`${percentageData.expiredPer}%`}
            //       />
            //       <div
            //         className="bg-gray-300"
            //         style={{width: `${percentageData.noDataPer}%`}}
            //         title={`${percentageData.noDataPer}%`}
            //       />
            //     </div>
            //     <div className="mt-1 flex items-center justify-end gap-3 text-sm">
            //       <span className="inline-block h-3 w-3 rounded-full bg-green-500"></span>
            //       <span
            //         className="text-center"
            //         //style={{width: `${percentageData.activePer}%`}}
            //       >
            //         {percentageData.activePer}%
            //       </span>
            //       <span className="inline-block h-3 w-3 rounded-full bg-red-500"></span>
            //       <span
            //         className="text-center"
            //         // style={{width: `${percentageData.expiredPer}%`}}
            //       >
            //         {percentageData.expiredPer}%
            //       </span>
            //       <span className="inline-block h-3 w-3 rounded-full bg-gray-300"></span>
            //       <span
            //         className="text-center"
            //         //style={{width: `${percentageData.noDataPer}%`}}
            //       >
            //         {percentageData.noDataPer}%
            //       </span>
            //     </div>
            //   </div>
            //   {/* <div className="relative flex w-full items-center">
            //     <div className="relative mx-0 flex-grow">
            //       <div className="h-3 w-full rounded-full bg-gray-300">
            //         <div className="absolute top-0 h-3 w-3 rounded-full border-2 border-gray-400 bg-white"></div>
            //         <div
            //           className="h-3 rounded-full bg-green-500"
            //           style={{width: permitdatas.permitpercentage}}
            //         ></div>
            //         <div className="absolute right-0 top-0 h-3 w-3 rounded-full border-2 border-gray-400 bg-white"></div>
            //       </div>
            //       {permitdatas.permitpercentage.replace(".00", "") !== "0%" &&
            //         permitdatas.permitpercentage.replace(".00", "") !==
            //           "100%" && (
            //           <div
            //             className={twMerge(
            //               "absolute top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-gray-400 bg-white"
            //             )}
            //             style={{left: `${permitdatas.permitpercentage}`}}
            //           ></div>
            //         )}
            //     </div>
            //   </div> */}
            //   {/*<div className="mt-2 h-2 w-full rounded bg-[#C1E8C6]">
            //     <div
            //       className="h-2 rounded bg-[#349C42]"
            //       style={{width: permitdatas.permitpercentage}}
            //     ></div>
            //   </div>*/}
            //   {/* <div className="flex justify-between">
            //     <span className="items-start text-xs">Active</span>
            //     <span className="items-end text-xs">Expired</span>
            //   </div> */}
            //   <div className=" grid grid-cols-3 flex-row gap-2 p-1">
            //     <div
            //       className="p-1"
            //       onClick={() =>
            //         openPopup({title: "Permit Summary", filter: {status: [1]}})
            //       }
            //     >
            //       <div className="flex items-center">
            //         <div className="h-4 w-1 rounded-2xl bg-[#349C42]"></div>
            //         <h5 className="pl-3 text-2xl font-semibold ">
            //           {permitdatas.active}
            //         </h5>
            //       </div>
            //       <h5 className="text-xs font-semibold">Active Permits</h5>
            //     </div>
            //     <div
            //       className="p-1"
            //       onClick={() =>
            //         openPopup({title: "Permit Summary", filter: {status: [2]}})
            //       }
            //     >
            //       <div className="flex items-center">
            //         <div className="h-4 w-1 rounded-2xl bg-[#FF5555]"></div>
            //         <h5 className="pl-3 text-2xl font-semibold ">
            //           {permitdatas.expired}
            //         </h5>
            //       </div>
            //       <h5 className="text-xs font-semibold">Expired Permits</h5>
            //     </div>
            //     <div
            //       className="p-1"
            //       onClick={() =>
            //         openPopup({title: "Permit Summary", filter: {status: [3]}})
            //       }
            //     >
            //       <div className="flex items-center">
            //         <div className="h-4 w-1 rounded-2xl bg-[#A3A4A4]"></div>
            //         <h5 className="pl-3 text-2xl font-semibold">
            //           {permitdatas.noData}
            //         </h5>
            //       </div>
            //       <h5 className="text-xs font-semibold">No Data</h5>
            //     </div>
            //   </div>
            // </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PollutionSummaryWidget;
